import { render } from "./orderResendEmail.vue?vue&type=template&id=24d31d73&scoped=true"
import script from "./orderResendEmail.vue?vue&type=script&lang=js"
export * from "./orderResendEmail.vue?vue&type=script&lang=js"

import "./orderResendEmail.vue?vue&type=style&index=0&id=24d31d73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d31d73"]])

export default __exports__